import { useMemo } from "react";

const TripInfoLeftSection = ({
  tripInfo,
  id,
  tripDetailsPassenger,
  tripDetailsLuggage,
  services,
}) => {
  const getStatusInfo = useMemo(() => {
    const status = tripInfo?.status?.toLowerCase();

    const statusMap = {
      pending: { text: "Pending", color: "#F39C12" }, // Orange/Gold
      on_started: { text: "On Started", color: "#3498DB" }, // Blue
      ready: { text: "Ready", color: "#2ECC71" }, // Green
      on_going: { text: "Ongoing", color: "#3498DB" }, // Blue
      completed: { text: "Completed", color: "#2ECC71" }, // Green
      cancelled: { text: "Cancelled", color: "#E74C3C" }, // Red
    };

    return (
      statusMap[status] || {
        text: tripInfo?.status || "Unknown",
        color: "#95A5A6",
      }
    ); // Gray for unknown
  }, [tripInfo?.status]);
  return (
    <div className="w-full lg:w-[40%] bg-third rounded-3xl p-6 font-semibold flex flex-col gap-6">
      <h1 className="text-xl font-bold">Trip Information:</h1>
      <div className="flex flex-col gap-4">
        <p className="flex items-center gap-2 text-black">
          <span className="text-gray-400">Trip ID:</span>#{id}
        </p>
        <p
          className={`flex items-center gap-2 `}
          style={{
            color: getStatusInfo.color,
          }}
        >
          <span className="text-gray-400">Trip Status:</span>
          {getStatusInfo?.text}
        </p>
        <p className="flex items-center gap-2 text-black">
          <span className="text-gray-400">Start Date / Time:</span>
          {tripInfo?.start_time}
          AM
        </p>
        <p className="flex items-center gap-2 text-black">
          <span className="text-gray-400">End Date / Time:</span>
          {tripInfo?.end_time}
          AM
        </p>
        <p className="flex items-center gap-2 text-black">
          <span className="text-gray-400">Repeating Days:</span>Not recurring
        </p>
        <p className="flex items-center gap-2 text-black">
          <span className="text-gray-400">Booking Type:</span>
          {tripInfo?.booking_type}
        </p>

        <p className="flex items-center gap-2 text-black">
          <span className="text-gray-400">Seats Count:</span>
          {tripDetailsPassenger ? tripDetailsPassenger?.seats_number : "-"}{" "}
          Seats
        </p>
        <p className="flex items-center gap-2 text-black">
          <span className="text-gray-400">Price per Seat:</span>
          {tripDetailsPassenger ? tripDetailsPassenger.price_per_seat : "-"} SYP
        </p>
        <p className="flex items-center gap-2 text-black">
          <span className="text-gray-400">Total Weight:</span>
          {tripDetailsLuggage ? tripDetailsLuggage?.max_weight : "-"} kg
        </p>
        <p className="flex items-center gap-2 text-black">
          <span className="text-gray-400">Luggage Allowed:</span>
          {tripDetailsPassenger
            ? tripDetailsPassenger?.accept_luggage
              ? "Yes"
              : "No"
            : "-"}
        </p>
        <p className="flex items-center gap-2 text-black">
          <span className="text-gray-400">Animals Allowed:</span>
          {tripDetailsPassenger
            ? tripDetailsPassenger?.accept_pets
              ? "Yes"
              : "No"
            : "-"}
        </p>
      </div>
      <div className="flex flex-col gap-3">
        <h3 className="text-gray-400">Amenities:</h3>
        {services?.map((el) => (
          <p key={el?.id} className="flex items-center gap-2">
            <p className="w-3 h-3 rounded-full bg-secondary"></p>
            {el?.name}
          </p>
        ))}
        <h3 className="text-gray-400">Driver Notes:</h3>
        <p className="text-black">“{tripInfo?.note}”</p>
      </div>
    </div>
  );
};

export default TripInfoLeftSection;
